import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { Col } from "reactstrap";
import Icon, { IconName } from "src/components/Icon/Icon";
import { formatDateTime } from "src/views/CampaignDetail/utils";
import * as S from "../../../../../constants/StringConstants";
import CommentsFields from "./CommentsFields";

const CommentsForm = ({ commentDetails, newComment, setNewComment }) => {
  const [comments, setComments] = useState([]);
  const [isAddingComment, setIsAddingComment] = useState(false);

  useEffect(() => {
    if (commentDetails?.listCommentHistoryDetailDTO) {
      setComments(
        commentDetails.listCommentHistoryDetailDTO.map(comment => ({
          id: comment.id,
          author: comment.createdByUserID ? `User ${comment.createdByUserID}` : "Unknown",
          date: comment.created,
          content: comment.comment,
        })),
      );
    }
  }, [commentDetails]);

  const priorityOptions = get(commentDetails, "selectPriorityList", []) || [];

  const handleSaveComment = () => {
    if (!newComment.trim()) return;

    const newCommentData = {
      content: newComment,
    };

    setComments([...comments, newCommentData]);
    setIsAddingComment(false);
  };

  const handleCancelComment = () => {
    setNewComment("");
    setIsAddingComment(false);
  };

  return (
    <>
      <CommentsFields priorityOptions={priorityOptions} />

      <h5 className="comments-detail__comments-title">{S.APP_COMMENTS_SECTION_TITLE}</h5>

      <Col sm="6" className="comments-detail__comments-container">
        <div>
          {comments.length > 0 ? (
            comments.map(comment => (
              <div key={comment.id}>
                <span className="comments-detail__comments-title">{comment.author}</span>{" "}
                <span style={{ fontSize: "10px" }}>{formatDateTime(comment.date)}</span>
                <div className="comments-detail__comments-body">{comment.content}</div>
                <hr />
              </div>
            ))
          ) : (
            <p>No comments available.</p>
          )}

          {isAddingComment ? (
            <>
              <Col sm="12" className="comments-detail__user-comment-container">
                <div>You</div>
                <textarea
                  placeholder="Write a comment..."
                  defaultValue={newComment}
                  onChange={e => setNewComment(e.target.value)}
                />
              </Col>

              <div className="comments-detail__buttons-container">
                <button type="button" onClick={handleSaveComment} disabled={!newComment.trim()}>
                  <Icon name={IconName.Save} size="24px" />
                  <span>{S.APP_COMMENTS_BUTTON_SAVE_LABEL}</span>
                </button>

                <button type="button" onClick={handleCancelComment}>
                  <Icon name={IconName.Cancel} size="24px" />
                  <span>{S.APP_COMMENTS_BUTTON_CANCEL_LABEL}</span>
                </button>
              </div>
            </>
          ) : (
            <button
              type="button"
              className="comments-detail__add-comment-button"
              onClick={() => setIsAddingComment(true)}>
              <Icon name={IconName.PlusBlue} size="24px" />
              <span>{S.APP_COMMENTS_BUTTON_COMMENT_LABEL}</span>
            </button>
          )}
        </div>
      </Col>
    </>
  );
};

export default CommentsForm;
